export const FETCH_LIST_BLOCK_REQUEST = "FETCH_LIST_BLOCK_REQUEST";
export const FETCH_LIST_BLOCK_SUCCESS = "FETCH_LIST_BLOCK_SUCCESS";
export const FETCH_LIST_BLOCK_FAILURE = "FETCH_LIST_BLOCK_FAILURE";

export const FETCH_LIST_ALL_BLOCK_REQUEST = "FETCH_LIST_ALL_BLOCK_REQUEST";
export const FETCH_LIST_ALL_BLOCK_SUCCESS = "FETCH_LIST_ALL_BLOCK_SUCCESS";
export const FETCH_LIST_ALL_BLOCK_FAILURE = "FETCH_LIST_ALL_BLOCK_FAILURE";

export const FETCH_BLOCK_REQUEST = "FETCH_BLOCK_REQUEST";
export const FETCH_BLOCK_SUCCESS = "FETCH_BLOCK_SUCCESS";
export const FETCH_BLOCK_FAILURE = "FETCH_BLOCK_FAILURE";

export const ADD_BLOCK_REQUEST = "ADD_BLOCK_REQUEST";
export const ADD_BLOCK_SUCCESS = "ADD_BLOCK_SUCCESS";
export const ADD_BLOCK_FAILURE = "ADD_BLOCK_FAILURE";

export const UPDATE_BLOCK_REQUEST = "UPDATE_BLOCK_REQUEST";
export const UPDATE_BLOCK_SUCCESS = "UPDATE_BLOCK_SUCCESS";
export const UPDATE_BLOCK_FAILURE = "UPDATE_BLOCK_FAILURE";

export const DELETE_BLOCK_REQUEST = "DELETE_BLOCK_REQUEST";
export const DELETE_BLOCK_SUCCESS = "DELETE_BLOCK_SUCCESS";
export const DELETE_BLOCK_FAILURE = "DELETE_BLOCK_FAILURE";

export const RESET_CURRENT_BLOCK = "RESET_CURRENT_BLOCK";
